import './SecretInput.less';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import type { InputProps, InputRef } from 'antd';
import { forwardRef, useState } from 'react';

// A text field masked by CSS: any `type="password"` input wakes the browser's password manager.
const PASSWORD_MANAGER_OPT_OUT = {
  'data-lpignore': 'true',
  'data-1p-ignore': 'true',
  'data-bwignore': 'true',
  'data-form-type': 'other',
};

const SecretInput = forwardRef<InputRef, Omit<InputProps, 'type'>>(
  function SecretInput({ className, ...props }, ref) {
    const [shown, setShown] = useState(false);

    return (
      <Input
        {...props}
        {...PASSWORD_MANAGER_OPT_OUT}
        ref={ref}
        type="text"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        className={`SecretInput${shown ? '' : ' SecretInput--masked'}${className ? ` ${className}` : ''}`}
        suffix={
          <button
            type="button"
            className="SecretInput__toggle"
            aria-label={shown ? 'Hide' : 'Show'}
            onClick={() => setShown(value => !value)}
          >
            {shown ? <EyeOutlined /> : <EyeInvisibleOutlined />}
          </button>
        }
      />
    );
  },
);

export default SecretInput;
